/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/core';
import { useModal } from './hooks';
import { keylineHeight, padding } from './internal/constants';
const headerStyles = css({
  display: 'flex',
  padding: padding,
  paddingBottom: `${padding - keylineHeight}px`,
  position: 'relative',
  alignItems: 'center',
  justifyContent: 'space-between'
});

const ModalHeader = props => {
  const {
    children,
    testId: userDefinedTestId
  } = props;
  const {
    testId: modalTestId
  } = useModal();
  const testId = userDefinedTestId || modalTestId && `${modalTestId}--header`;
  return jsx("div", {
    css: headerStyles,
    "data-testid": testId
  }, children);
};

export default ModalHeader;